
import React, { useState , useRef, useEffect , useMemo } from 'react';
import "../../../../../../../../StyleSheet/MainComponent/Innergeolocation.scss";
import arroicon from  "../../../../../../../../Assets/AppComponent/Customersupport_icon/DetailArrow.svg"
import ticketd from "../../../../../../../../Assets/AppComponent/Geolocation_popup/Tickets.svg"
import downarrow from  "../../../../../../../../Assets/AppComponent/Geolocation_popup/Arrow.svg"
import closeicon from "../../../../../../../../Assets/AppComponent/Group 427320024.svg"
import { useDispatch, useSelector } from 'react-redux';
import  {resetClientData_internal, resetInternalRegionData ,resetZoneData_internal}  from "../../../../../../../../Redux/Slice";
import _ from "lodash";
import boximg from "../../../../../../../../Assets/AppComponent/Group 427320177.svg";
import searchicon from "../../../../../../../../Assets/AppComponent/Customersupport_icon/Searchicon.svg"



export const Innergeorecords = ({show , setshow,Table_name ,innerdatas}) => {
  const [selectedRegion, setSelectedRegion] = useState();
    const [openZones, setOpenZones] = useState({});
  const dispatch = useDispatch();
  const state = useSelector((state)=>state)
  const scrollRef = useRef(null);
  const [ButtonTab, setButtonTabs] = useState([]);
  const [ListedRecords , setrecordlisted] = useState([]);
  const [InnerTablist  , setinnertablist] = useState([]);
  const [search , setsearch] = useState("")


  const [datas, setdatas] = useState({
    state:Table_name =="state" ? innerdatas?.id :"",
    region:Table_name == "region" ? innerdatas?.id : "",
        zone:Table_name == "zone" ? innerdatas?.id : "",

    
  })

  const scrollTabs = (direction) => {
    const scrollAmount = 150;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };



 const toggleZone = (zoneId) => {
  // If already open, close it and clear the zone in datas
  if (openZones === zoneId) {
    setOpenZones(null);
    setdatas(prev => ({
      ...prev,
      zone: null,
    }));
  } else {
    setOpenZones(zoneId);
    setdatas(prev => ({
      ...prev,
      zone: zoneId,
    }));
  }
};


  useEffect(()=>{
    if(Table_name =="state" && datas.state != "" && datas.state != null){
      const payload ={
        state:datas.state,
        page_sze:"",
        page:1,
      }
      dispatch(resetInternalRegionData(payload))

    }
  },[Table_name])

   useEffect(()=>{
    if(Table_name =="state" && datas?.region !="" && datas?.region != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        page_sze:20,
        page:1,
        search:search,

      }
      dispatch(resetZoneData_internal(payload))

    }
  },[Table_name, datas?.region,search])


     useEffect(()=>{
    if(Table_name =="region" && datas?.region !="" && datas?.region != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        page_sze:"",
        page:1,

      }
      dispatch(resetZoneData_internal(payload))

    }
  },[Table_name, datas?.region])


     useEffect(()=>{
    if(Table_name =="zone" && datas?.zone !="" && datas?.zone != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        zone:datas?.zone,
        page_sze:"",
        page:1,

      }
      dispatch(resetZoneData_internal(payload))

    }
  },[Table_name,])


   useEffect(()=>{
    if(Table_name =="state" && datas?.state !="" && datas?.region !="" && datas?.zone != "" && datas?.zone != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        zone:datas?.zone,
        page_sze:20,
        page:1,
        search:search,

      }
      dispatch(resetClientData_internal(payload))

    }
  },[Table_name , datas ,search])


   useEffect(()=>{
    if(Table_name =="region" && datas?.zone != "" && datas?.zone != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        zone:datas?.zone,
        page_sze:20,
        page:1,
        search:search,

      }
      dispatch(resetClientData_internal(payload))

    }
  },[Table_name , datas?.zone ,search])

  

   useEffect(()=>{
    if(Table_name =="zone" && datas?.zone != "" && datas?.zone != null){
      const payload ={
        state:datas?.state,
        region:datas?.region,
        zone:datas?.zone,
        page_sze:20,
        page:1,
        search:search,

      }
      dispatch(resetClientData_internal(payload))

    }
  },[Table_name  ,search])


useEffect(() => {
      if(Table_name =="state"){
  const mappedData = state.internalsupport_regionlist.internal_table_data.map(item => ({
    id: item.region_id__id,
    name: item.region_id__region_name,
  }));
  
  setButtonTabs(mappedData);
  setdatas({
    ...datas,
    region:mappedData?.[0]?.id
  })
  setSelectedRegion(mappedData?.[0]?.name)
}
}, [state.internalsupport_regionlist.internal_table_data]);
  
  console.log(ButtonTab ,"mappedData 023984", datas);

useEffect(() => {
      if(Table_name =="state"){

  const mappedData = state.internalsupport_zone.zone_table_data.map(item => ({
    id: item.zone_id__id,
    name: item.zone_id__zone_name,
    totalTickets:item?.group_tickets
  }));
  setrecordlisted(mappedData);

}
}, [state.internalsupport_zone.zone_table_data , datas]);

useEffect(() => {
      if( datas?.zone !="" && Table_name =="state" && datas?.zone != null){
  const mappedData = state.internalsupport_client.client_table_data.map(item => ({
    id: item.client_id__id,
    name: item.client_id__client_name,
        totalTickets:item?.group_tickets,
        parentid:datas?.zone

  }));
  setinnertablist(mappedData);
}
}, [state.internalsupport_client.client_table_data , datas]);
  


  function tochange(value) {
  debouncedSearch(value);  // call debounced search
}

const debouncedSearch = useMemo(
  () =>
    _.debounce((val) => {
      setsearch(val);     // set actual search state after 500ms
    }, 500),
  []
);

// Cancel debounce on unmount
useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);



useEffect(() => {
      if(Table_name =="region"){

  const mappedData = state.internalsupport_zone.zone_table_data.map(item => ({
    id: item.zone_id__id,
    name: item.zone_id__zone_name,
    totalTickets:item?.group_tickets
  }));
  setButtonTabs(mappedData);
      setdatas(prev => ({
        ...prev,
        zone: mappedData[0]?.id
      }));
  
    
    setSelectedRegion(mappedData?.[0]?.name)

}
}, [state.internalsupport_zone.zone_table_data , datas?.region]);


useEffect(() => {
      if( datas?.zone !="" && Table_name =="region" && datas?.zone != null){
  const mappedData = state.internalsupport_client.client_table_data.map(item => ({
    id: item.client_id__id,
    name: item.client_id__client_name,
        totalTickets:item?.group_tickets,
        parentid:datas?.zone

  }));
  setrecordlisted(mappedData);
}
}, [state.internalsupport_client.client_table_data , datas?.state , datas?.region , datas?.zone]);
  

/// zones


useEffect(() => {
      if(Table_name =="zone"){

  const mappedData = state.internalsupport_zone.zone_table_data.map(item => ({
    id: item.zone_id__id,
    name: item.zone_id__zone_name,
    totalTickets:item?.group_tickets
  }));
  setButtonTabs(mappedData);
      setdatas(prev => ({
        ...prev,
        zone: mappedData[0]?.id
      }));

    setSelectedRegion(mappedData?.[0]?.name)

}
}, [state.internalsupport_zone.zone_table_data ]);


useEffect(() => {
      if( datas?.zone !="" && Table_name =="zone" && datas?.zone != null){
  const mappedData = state.internalsupport_client.client_table_data.map(item => ({
    id: item.client_id__id,
    name: item.client_id__client_name,
        totalTickets:item?.group_tickets,
        parentid:datas?.zone

  }));
  setrecordlisted(mappedData);
}
}, [state.internalsupport_client.client_table_data , datas?.state , datas?.region , datas?.zone]);
  

 console.log(InnerTablist ,"InnerTablistopi dkf",ButtonTab);

  return (
    <div className="Inner_Geo_locationPopups">
    <div className='inner_popups'>
          <div className="geo-header">
        <h2>{innerdatas?.name}</h2>
     
      <div className="search-Close">
<div className='search-container'>
    <span className="search-icon">
    <img src={searchicon} alt="search" />
  </span>
  <input
    type="text"
  onChange={(e) => tochange(e.target.value)}
    placeholder="Search..."
    className="search-input"
  />
</div>


             <button onClick={()=>{
            setshow(false)
           }}>
         <img src={closeicon}/>
           </button>


</div>

      </div>
            {ButtonTab.length != 0  && (

      <div className="geo-tabs-wrapper">
      <div className='InnerTabs'>
                {ButtonTab.length > 8 &&(

          <div className="Details_icons" onClick={() => scrollTabs("left")}>
          <img src={arroicon} className="arrow left" alt="left-arrow" />
        </div>
                )}

        <div className="geo-tabs" ref={scrollRef}>
          {ButtonTab.map(region => (
            <button
              key={region.id}
              className={`tab-button ${selectedRegion === region.name ? 'active' : ''}`}
              onClick={() => {
                console.log(region ,"asdiaposdi region");
                setSelectedRegion(region?.name)
                setdatas({
                  ...datas,
                  region:Table_name =="state" ? region?.id :datas.region,
                  zone: Table_name == "region"? region?.id :datas.zone
                })


              }}
            >
              {region.name}
            </button>
          ))}
        </div>
                {ButtonTab.length > 8 &&(

        <div className="Details_icons" onClick={() => scrollTabs("right")}>
          <img src={arroicon} className="arrow right" alt="right-arrow" />
        </div>
                )}
        </div>
      </div>
            )}


      {/* <div className="zone-container">
      {Table_name =="state"?
      
<>
      {ListedRecords.map((zone, id) => (
          <div className="zone-block" key={id}>
            <div className="zone-title" onClick={() => toggleZone(zone.id)}>
<span className='HoldwithNames'>
               <span className='InnerDownArrows'>
  <img
    src={downarrow}
    className={openZones == zone.id ? 'arrow open' : 'arrow'}
    alt="toggle-arrow"
  />
</span>
                  <span>{zone.name}</span>
</span>

              <span>{`${zone.totalTickets} Tickets`}</span>
            </div>

            {openZones  == zone.id && (
              InnerTablist.length > 0 ? (
                InnerTablist.map((client, index) => (
                  <div className="client-row" key={index}>
                    <div className="client-name">
                        <img src={ticketd}/>
                        {client.name}</div>
                    <div className="ticket-count">{client.totalTickets} Tickets</div>
                  </div>
                ))
              ) 
              
              : (
                <div className="text-center">{"No data available"}</div>
              )
            )}
          </div>
        ))}
</>

:
<>
  {ListedRecords.map((zone, id) => (
          <div className="zone-block" key={id}>
            <div className="zone-title" >
<span className='HoldwithNames'>
     <span></span>
                  <span>{zone.name}</span>
</span>

              <span>{`${zone.totalTickets} Tickets`}</span>
            </div>

            {openZones  == zone.id && (
              InnerTablist.length > 0 ? (
                InnerTablist.map((client, index) => (
                  <div className="client-row" key={index}>
                    <div className="client-name">
                        <img src={ticketd}/>
                        {client.name}</div>
                    <div className="ticket-count">{client.totalTickets} Tickets</div>
                  </div>
                ))
              ) : (
                <div className="ticket-count-only">{zone.totalTickets} Tickets</div>
              )
            )}
          </div>
        ))}



</>

    }

      </div> */}
          <div className="zone-container">
  {ListedRecords.length === 0 ? (
    <div className="Dusbinbacktabls" style={{height:"376px"}}>
      <div>
        <img src={boximg} />
        <p className="text-center">No Data Available</p>
      </div>
    </div>
  ) : Table_name === "state" ? (
    <>
      {ListedRecords.map((zone, id) => (
        <div className="zone-block" key={id}>
          <div className="zone-title" onClick={() => toggleZone(zone.id)}>
            <span className='HoldwithNames'>
              <span className='InnerDownArrows'>
                <img
                  src={downarrow}
                  className={openZones === zone.id ? 'arrow open' : 'arrow'}
                  alt="toggle-arrow"
                />
              </span>
              <span>{zone.name}</span>
            </span>
            <span>{`${zone.totalTickets} Tickets`}</span>
          </div>

          {openZones === zone.id && (
            InnerTablist.length > 0 ? (
              InnerTablist.map((client, index) => (
                <div className="client-row" key={index}>
                  <div className="client-name">
                    <img src={ticketd} />
                    {client.name}
                  </div>
                  <div className="ticket-count">{client.totalTickets} Tickets</div>
                </div>
              ))
            ) : (
              <div className="text-center">No data available</div>
            )
          )}
        </div>
      ))}
    </>
  ) : (
    <>
      {ListedRecords.map((zone, id) => (
        <div className="zone-block" key={id}>
          <div className="zone-title">
            <span className='HoldwithNames'>
              <span></span>
              <span>{zone.name}</span>
            </span>
            <span>{`${zone.totalTickets} Tickets`}</span>
          </div>

          {openZones === zone.id && (
            InnerTablist.length > 0 ? (
              InnerTablist.map((client, index) => (
                <div className="client-row" key={index}>
                  <div className="client-name">
                    <img src={ticketd} />
                    {client.name}
                  </div>
                  <div className="ticket-count">{client.totalTickets} Tickets</div>
                </div>
              ))
            ) : (
              <div className="text-center">No data available</div>
            )
          )}
        </div>
      ))}
    </>
  )}
</div>

    </div>
    </div>
  );
};
